import {logEvent} from '.';
import {MouseClickProps, ErrorProps} from './googleAnalyticsEvents.type';

export function trackPageView() {
  logEvent({event: 'page_view'});
}

export function trackMouseClicks(
  {type, label, target}: MouseClickProps,
  additionalInfo?: Record<string, string>
) {
  logEvent({
    event: 'click',
    additionalInfo: {
      type: type,
      label: label,
      targetHref: target,
      ...additionalInfo,
    },
  });
}
export function trackFormEvents(
  status: 'start' | 'success' | 'fail',
  additionalInfo?: Record<string, string>
) {
  logEvent({
    event: 'form',
    additionalInfo: {
      status: status,
      ...additionalInfo,
    },
  });
}
export function trackContentSearch(queryString: string) {
  logEvent({
    event: 'search',
    additionalInfo: {
      applied_filters: queryString,
    },
  });
}

export function trackErrorEvents(
  {type, errorStack}: ErrorProps,
  additionalInfo?: Record<string, string>
) {
  logEvent({
    event: 'error',
    additionalInfo: {
      type: type,
      errorStack: errorStack,
      ...additionalInfo,
    },
  });
}
export function trackFileDownload(
  status: 'success' | 'fail',
  additionalInfo: Record<string, string>
) {
  logEvent({
    event: 'download',
    additionalInfo: {
      status: status,
      ...additionalInfo,
    },
  });
}
